import i18n from "../../i18n";
import axios from "axios";

const actions = {
  bulkDeleteInspections(context, ids) {
    return axios
      .post("inspection/bulk-delete", { ids })
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("inspections.bulk.deletedMessage"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  bulkMoveInspections(context, { ids, category }) {
    return axios
      .post("inspection/bulk-move", { ids, category })
      .then((r) => {
        context.commit("CREATE_SNACKBAR", i18n.t("inspections.bulk.movedMessage"));
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  createInspection(context, value) {
    return axios
      .post("inspection", value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("snackbars.inspectionAdded", { name: r.data.title }),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  deleteInspection(context, val) {
    return axios
      .delete("inspection/" + val.id)
      .then(function (res) {
        context.commit("CREATE_SNACKBAR", i18n.t("snackbars.inspectionDeleted"));
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  updateInspection(context, value) {
    return axios
      .put("inspection/" + value.id, value)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getSingleInspection(context, id) {
    return axios
      .get("inspection/" + id)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getAllInspections(context) {
    return axios
      .get("inspection")
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getPdfInspection(context, id) {
    return axios
      .get("inspection/" + id + "/pdf")
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  addProof(context, value) {
    return axios
      .post("inspection/" + value.id + "/proof", value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("snackbars.inspectionProofAdded"),
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  uploadAttachmentToTicketFromTask(context, value) {
    return axios
      .post(`inspection/${value.id}/ticket/${value.ticketId}/attachment`, value)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
};

export default actions;
